export default __webpack_public_path__ + "logo-small-9N6.png";